export const getExperienceSlice = (state) => state.experiences;
export const getBrand = (state) => state.initialProps.brand;
